module.exports = {"cooking_board_title":"Cooking","ready_board_title":"Ready","404_not_found":"404 - Not found","not_found_text":"It looks like the page you have requested doesn’t exist.\nPlease check you’ve typed the URL correctly or begin from the homepage.","403_access_denied":"403 - Access denied","access_denied_text":"Sorry, you’re not allowed to access this page.","monitor_error_title":"Error","monitor_error_text":"Food monitor is not available","monitor_error_desc":"The function might be disabled or connection URL is outdated."}


//////////////////
// WEBPACK FOOTER
// ./lang/en/food-monitor-en.json
// module id = 880
// module chunks = 6